// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"S5-z","displaySixCardTiles":"T5-z"};